export default __webpack_public_path__ + "static/media/match.08f403c2.png";